__turbopack_context__.v({
  "background": "styles-module-scss-module__8yqkdG__background",
  "background__clouds": "styles-module-scss-module__8yqkdG__background__clouds",
  "background__gradient": "styles-module-scss-module__8yqkdG__background__gradient",
  "brand": "styles-module-scss-module__8yqkdG__brand",
  "brand__block": "styles-module-scss-module__8yqkdG__brand__block",
  "brand__description": "styles-module-scss-module__8yqkdG__brand__description",
  "brand__image": "styles-module-scss-module__8yqkdG__brand__image",
  "brand__text": "styles-module-scss-module__8yqkdG__brand__text",
  "button": "styles-module-scss-module__8yqkdG__button",
  "buttons": "styles-module-scss-module__8yqkdG__buttons",
  "cloud": "styles-module-scss-module__8yqkdG__cloud",
  "cloud__l": "styles-module-scss-module__8yqkdG__cloud__l",
  "cloud__m": "styles-module-scss-module__8yqkdG__cloud__m",
  "cloud__s1": "styles-module-scss-module__8yqkdG__cloud__s1",
  "cloud__s2": "styles-module-scss-module__8yqkdG__cloud__s2",
  "cloud__xl": "styles-module-scss-module__8yqkdG__cloud__xl",
  "cloud__xs1": "styles-module-scss-module__8yqkdG__cloud__xs1",
  "cloud__xs2": "styles-module-scss-module__8yqkdG__cloud__xs2",
  "content": "styles-module-scss-module__8yqkdG__content",
  "description": "styles-module-scss-module__8yqkdG__description",
  "image": "styles-module-scss-module__8yqkdG__image",
  "inner": "styles-module-scss-module__8yqkdG__inner",
  "link": "styles-module-scss-module__8yqkdG__link",
  "outer": "styles-module-scss-module__8yqkdG__outer",
  "title": "styles-module-scss-module__8yqkdG__title",
  "title__accent": "styles-module-scss-module__8yqkdG__title__accent",
  "wrapper": "styles-module-scss-module__8yqkdG__wrapper",
});
